// extracted by mini-css-extract-plugin
export default {"root":"Link__root--2v_zH"};